import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "./404.scss";

const NotFound404 = ({ hideHeaderFooterSetter }) => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    
    const [count, setCount] = useState(10);

    const staticData = {
        errorTitle: {
            ua: '404',
            en: '404',
            ru: '404',
            pl: '404',
            de: '404',
            es: '404',
        },
        errorSubtitle: {
            ua: 'Ой, лишенько!',
            en: 'Oops!',
            ru: 'Упс!',
            pl: 'Ups!',
            de: 'Hoppla!',
            es: '¡Vaya!',
        },
        errorText: {
            ua: 'Ця сторінка недоступна або посилання некоректне. Повернення на головну відбудеться через {count} секунд, або скористайтеся кнопкою нижче.',
            en: 'This page is unavailable or the link is incorrect. You will be redirected to the homepage in {count} seconds, or use the button below.',
            ru: 'Эта страница недоступна или ссылка некорректна. Возврат на главную произойдет через {count} секунд, или воспользуйтесь кнопкой ниже.',
            pl: 'Ta strona jest niedostępna lub link jest nieprawidłowy. Powrót na stronę główną nastąpi za {count} sekund, lub użyj poniższego przycisku.',
            de: 'Diese Seite ist nicht verfügbar oder der Link ist falsch. Sie werden in {count} Sekunden zur Startseite weitergeleitet, oder nutzen Sie den untenstehenden Button.',
            es: 'Esta página no está disponible o el enlace es incorrecto. Serás redirigido a la página principal en {count} segundos, o utiliza el botón de abajo.',
        },
        button: {
            text: {
                ua: 'На головну',
                en: 'Home',
                ru: 'На главную',
                pl: 'Strona główna',
                de: 'Startseite',
                es: 'Inicio',
            },
            link: '/',
        },
    };

    useEffect(() => {
        if (hideHeaderFooterSetter) hideHeaderFooterSetter(true);

        return () => {
            if (hideHeaderFooterSetter) hideHeaderFooterSetter(false);
        };
    }, [hideHeaderFooterSetter]);

    useEffect(() => {
        if (count === 0) {
            navigate(staticData.button.link, { replace: true });
            return;
        }

        const timer = setTimeout(() => setCount((prev) => prev - 1), 1000);
        return () => clearTimeout(timer);
    }, [count, navigate, staticData.button.link]);

    return (
        <div className="wrapper__404">
            <h5 className='error__404__title'>
                {staticData.errorTitle?.[currentLang]?.split("")?.map((digit, index) => (
                    <span key={index} className={`fall-digit delay-${index}`}>
                        {digit}
                    </span>
                )) || staticData.errorTitle?.en?.split("")?.map((digit, index) => (
                    <span key={index} className={`fall-digit delay-${index}`}>
                        {digit}
                    </span>
                ))}
            </h5>
            <p className='error__404__subtitle'>
                {staticData.errorSubtitle?.[currentLang] || staticData.errorSubtitle?.en}
            </p>
            <p className='error__404__text'>
                {staticData.errorText?.[currentLang]?.replace("{count}", count) || 
                 staticData.errorText?.en?.replace("{count}", count)}
            </p>
            <button
                className="error__404__button"
                onClick={() => navigate(staticData.button.link, { replace: true })}
            >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                {staticData.button.text?.[currentLang] || staticData.button.text?.en}
            </button>
        </div>
    );
};

export default NotFound404;